// extracted by mini-css-extract-plugin
export default {"row-social":"social_row-social__5-UC6","social-button":"social_social-button__G4XJv"};